<div class="dashboard">
    <div class="header">
      <div class="company-info">
        <div class="user-details">
        <span class="user-name">{{user_details?.name}} ({{user_details?.email}}) </span>
        <span class="company-name">{{company_name}}</span>
      </div>
        <img src="../../assets/img/notification-icon.png" alt="Notification" class="header-icon">
        <!-- <img src="../../assets/img/logout-icon.png" alt="Logout" class="header-icon"> -->
        <i class="material-icons" (click)="gotolandingpage()">dashboard</i>
        <i class="material-icons" (click)="logout()">logout</i>
      </div>
    </div>
    <div class="content">
      <ng-container *ngFor="let item of dashboardItems">
        <div class="dashboard-item" (click)="onClick(item.path)" *ngIf="!(item.title === 'Settings' && user_details?.id !== 1)">
          <img [src]="item.icon" alt="{{ item.title }}">
          <span class="title">{{ item.title }}</span>
          <span class="description">{{ item.description }}</span>
        </div>
      </ng-container>
    </div>
  </div>
